import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  inner: CSSProperties
  label: CSSProperties
  actionsWrapper: CSSProperties
} = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderRadius: 8,
    padding: '2px 4px 2px 10px',
    transition: 'background-color 0.15s ease',
  },
  inner: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 0',
    minWidth: 0,
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexShrink: 0,
  },
}

export default styles
